/* Mats · Productos sugeridos (sections/mats-product-recs.liquid)
   - related / complementary: pide la sección a /recommendations/products (Section Rendering API)
   - recent: lee localStorage «mats:recent» (lo rellena mats-product.js) y pide cada tarjeta a
     /products/<handle>?section_id=mats-wish-card (misma tarjeta que Guardados) */
(() => {
  if (window.__matsRecs) return;
  window.__matsRecs = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const syncWish = (scope) => {
    if (!window.MatsWishlist) return;
    scope.querySelectorAll('[data-mats-wish]').forEach((b) => b.setAttribute('aria-pressed', String(window.MatsWishlist.has(b.dataset.matsWish))));
  };

  const hide = (el) => {
    const section = el.closest('.shopify-section');
    (section || el).hidden = true;
  };

  async function loadRecent(el, grid) {
    let list = [];
    try { list = JSON.parse(localStorage.getItem('mats:recent') || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];
    const handles = list.filter((h) => h && h !== el.dataset.handle).slice(0, Number(el.dataset.limit) || 4);
    if (!handles.length) { hide(el); return; }
    const parser = new DOMParser();
    const cards = await Promise.all(handles.map(async (h) => {
      try {
        const res = await fetch(`${root}products/${encodeURIComponent(h)}?section_id=mats-wish-card`, { credentials: 'same-origin' });
        if (!res.ok) return '';
        const doc = parser.parseFromString(await res.text(), 'text/html');
        const card = doc.querySelector('.mats-card');
        return card ? `<div class="mb-rc__item">${card.outerHTML}</div>` : '';
      } catch (e) { return ''; }
    }));
    const html = cards.join('');
    if (!html) { hide(el); return; }
    grid.innerHTML = html;
    syncWish(grid);
  }

  async function loadRecs(el, grid) {
    try {
      const res = await fetch(el.dataset.url, { credentials: 'same-origin' });
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-mb-rc-grid]');
      if (!fresh || !fresh.querySelector('.mats-card')) { hide(el); return; }
      grid.innerHTML = fresh.innerHTML;
      syncWish(grid);
    } catch (e) { hide(el); }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-mb-rc]').forEach((el) => {
      if (el.__mbRc) return;
      el.__mbRc = true;
      const grid = el.querySelector('[data-mb-rc-grid]');
      if (!grid) return;
      if (el.dataset.source === 'recent') loadRecent(el, grid);
      else if (el.dataset.fetch === 'true') loadRecs(el, grid);
      else if (!grid.querySelector('.mats-card') && !window.Shopify?.designMode) hide(el);
      else syncWish(grid);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
